import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import axiosInstance from "../services/axiosInstance";
import UpdatePinPopup from "../Popup/updatePinPopup";
import Cookies from "js-cookie";

const ProfileInfo = () => {
  const [showPinInputs, setShowPinInputs] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [formData, setFormData] = useState({
    pin: "",
    cpin: "",
  });
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const { userData } = useContext(UserContext);
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const HandleClosePopup = () => setOpenPopup(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "pin" && (!/^\d*$/.test(value) || value.length > 4)) return;
    if (id === "cpin" && (!/^\d*$/.test(value) || value.length > 4)) return;
    setFormData({ ...formData, [id]: value });
    // Reset error for the field
    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!/^\d{4}$/.test(formData.pin)) {
      isValid = false;
      newErrors.pin = "Die Pin muss genau 4 Ziffern haben.";
    }
    if (!/^\d{4}$/.test(formData.cpin)) {
      isValid = false;
      newErrors.cpin = "Die Pin muss genau 4 Ziffern haben.";
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      //console.log("Form submitted:", formData);
      updateUserPIN();
    }
  };

  useEffect(() => {
    if (
      userData == null &&
      (Cookies.get("userData") === undefined ||
        Cookies.get("userData") === null)
    ) {
      navigate("/");
    }
  }, []);

  const updateUserPIN = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/userManagement/updatePIN",
        {
          UID: userData?.user?.uid,
          Pin: formData.pin,
          CPin: formData.cpin,
        }
      );
      if (response.isSuccess) {
        setOpenPopup(true);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      if (error.response.data.message || error.response.data) {
        const serverErrors = error.response.data?.message
          ? error.response.data.message
          : error.response.data;
        setFormError(
          serverErrors || "Ein unerwarteter Fehler ist aufgetreten."
        );
      } else {
        setFormError("Ein unerwarteter Fehler ist aufgetreten.");
      }
    }
  };

  const navigate = useNavigate();
  const DashboardPage = () => {
    navigate("/dashboard");
  };

  return (
    <div className="mt-5">
      <div className="border-gray border p-8 m-auto rounded-3xl 2xl:gap-12 gap-8">
        {/* <div className='w-[170px] text-center'>
              <div className="relative mb-4 after:content-[''] after:absolute after:right-0 after:bottom-0 after:w-8 after:h-8 after:bg-[url('./assets/images/add_a_photo.svg')] after:bg-white after:rounded-tl-lg after:bg-no-repeat after:bg-right">
                <img src='./icons/profile_img.jpg' alt='' />
              </div>
             <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1} className='!bg-transparent !text-center !capitalize !text-blue-600 !font-interBold !text-2xl !shadow-none !focus:animate-none !focus:transition-none !p-0'
              >
                Add New Photo
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) => console.log(event.target.files)}
                  multiple
                />
              </Button>
          </div> */}
        <div className="mt-5">
          <div className="md:flex flex-wrap ">
            <div className="md:w-1/2 2xl:mb-6 mb-3">
              <p className="text-gray-600 text-2xl font-interRegular !m-0">
                First Name:{" "}
                <span className="font-interBold !m-0">
                  {" "}
                  {userData?.user?.userFirstName}
                </span>
              </p>
            </div>
            <div className="md:w-1/2 2xl:mb-6 mb-3">
              <p className="text-gray-600 text-2xl font-interRegular !m-0">
                Last Name:{" "}
                <span className="font-interBold !m-0">
                  {userData?.user?.userLastName}
                </span>
              </p>
            </div>
            <div className="md:w-1/2 2xl:mb-6 mb-3">
              <p className="text-gray-600 text-2xl font-interRegular !m-0">
                Email:{" "}
                <span className="font-interBold !m-0">
                  {userData?.user?.userEmail}
                </span>
              </p>
            </div>
            <div className="md:w-1/2 2xl:mb-6 mb-3">
              <p className="text-gray-600 text-2xl font-interRegular !m-0">
                User Id:{" "}
                <span className="font-interBold !m-0">
                  {userData?.user?.uid}
                </span>
              </p>
            </div>
            <div className="md:w-1/2 2xl:mb-6 mb-3">
              <p className="text-gray-600 text-2xl font-interRegular !m-0">
                Role:{" "}
                <span className="font-interBold !m-0">
                  {userData?.roles?.roleName}
                </span>
              </p>
            </div>
          </div>
          <hr className="border-gray mb-7 mt-3"></hr>
          {formError && <p className="text-red text-sm">{formError}</p>}
          <form>
            <div className="">
              <div className="flex items-center gap-5 mb-3">
                {!showPinInputs && (
                  <>
                    <span className="text-gray-600 text-2xl font-interRegular w-40">
                      Pin:{" "}
                    </span>
                    <input
                      className="appearance-none border border-gray !text-lg rounded-lg w-[200px] font-inter py-2 px-5 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 !focus:border-blue-600 focus:outline-none !focus:shadow-outline !leading-5"
                      //id="pin"
                      type="number"
                      placeholder="****"
                      disabled
                    />
                    <button
                      className="opacity-40 rounded-lg p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] leading-5"
                      style={{
                        backgroundColor: "rgba(201, 226, 252, 0.3)",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      type="button"
                      onClick={() => setShowPinInputs(true)}
                    >
                      <img src="./icons/edit_square.svg" />
                    </button>
                  </>
                )}
              </div>
              {showPinInputs && (
                <div>
                  <div className="flex items-center gap-5 mb-3">
                    <span className="text-gray-600 text-2xl font-interRegular w-40">
                      Neue Pin eingeben:{" "}
                    </span>
                    <input
                      className={`appearance-none border border-gray !text-lg rounded-lg w-[200px] font-inter py-2 px-5 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 !focus:border-blue-600 !focus:outline-none !focus:shadow-outline !leading-5 ${
                        errors.pin ? "border-red" : ""
                      }`}
                      id="pin"
                      type="password"
                      placeholder="****"
                      value={formData.pin}
                      onChange={handleChange}
                      maxLength={4}
                    />
                    <button
                      className="opacity-40 rounded-lg p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] leading-5"
                      style={{
                        backgroundColor: "rgba(201, 226, 252, 0.3)",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      type="button"
                      onClick={() => setShowPinInputs(true)}
                    >
                      <img src="./icons/edit_square.svg" />
                    </button>
                    {errors.pin && (
                      <p className="text-red text-sm mt-1">{errors.pin}</p>
                    )}
                  </div>

                  <div className="flex items-center gap-5 mb-3">
                    <span className="text-gray-600 text-2xl font-interRegular w-40">
                      Neue Pin Bestätigen:{" "}
                    </span>
                    <input
                      className={`appearance-none border border-gray !text-lg rounded-lg w-[200px] font-inter py-2 px-5 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 !focus:border-blue-600 !focus:outline-none !focus:shadow-outline !leading-5 ${
                        errors.cpin ? "border-red" : ""
                      }`}
                      id="cpin"
                      type="password"
                      placeholder="****"
                      value={formData.cpin}
                      onChange={handleChange}
                      maxLength={4}
                    />
                    {errors.cpin && (
                      <p className="text-red text-sm mt-1">{errors.cpin}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="flex items-center justify-end gap-5 mt-5">
        <button
          className="px-5 py-2 text-xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
          type="button"
          onClick={DashboardPage}
        >
          Abbrechen
        </button>
        <button
          className="bg-blue uppercase  text-xl border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
          type="button"
          onClick={handleSubmit}
        >
          Speichern
        </button>
      </div>
      <UpdatePinPopup openPopUp={openPopup} closePopUp={HandleClosePopup} />
    </div>
  );
};

export default ProfileInfo;
